module.exports = "../../app/cells/components/modals/setup_wizard/cargo_alvo.erb";